export function optimizeFunction(value) {
  return value.replace(/(^\s+)|([^A-Za-z\s])|(\s+)/g, " ").trimStart();
}

export function allowAlphaNumericWithSpace(value) {
  return value.replace(/[^a-zA-Z0-9\s]/g, "");
}

export function allowAlphaNumeric(value) {
  return value.replace(/[^a-zA-Z0-9]/g, "");
}

export function allowNumber(value) {
  return value.replace(/[^\d]/g, "").trimStart();
}

// export function allowMobileNumber(value) {
//   // Only allow numbers and check if it starts with 8, 9, 7, or 6
//   const sanitizedValue = value.replace(/[^\d]/g, "").trimStart();

//   // Validate if the first digit is 8, 9, 7, or 6
//   if (/^[8976]\d*$/.test(sanitizedValue)) {
//     return sanitizedValue;
//   }

//   return ""; // Return an empty string if invalid
// }
export function allowMobileNumber(value) {
  // Allow only digits and an optional leading plus
  const sanitizedValue = value.replace(/[^\d+]/g, "").trimStart();

  // If it starts with +, strip it for validation, but keep it in the return
  const numberWithoutPlus = sanitizedValue.startsWith("+") ? sanitizedValue.slice(1) : sanitizedValue;

  // Validate if the first digit (after + if present) is 6, 7, 8, or 9
  if (/^[6789]\d*$/.test(numberWithoutPlus)) {
    return sanitizedValue;
  }

  return ""; // Return empty string if invalid
}

export function allowFloatingNumber(value) {
  // Allow only digits and optionally a single decimal point
  const cleanedValue = value.replace(/[^\d.]/g, "").trimStart();

  // Ensure only one decimal point exists
  const parts = cleanedValue.split(".");

  // If there's more than one decimal point, keep the first one and remove additional points
  if (parts.length > 2) {
    return `${parts[0]}.${parts[1]}`;
  }

  // Limit to 4 digits after the decimal point
  if (parts[1] && parts[1].length > 4) {
    parts[1] = parts[1].slice(0, 4);
  }

  // Reconstruct and return the valid number
  return parts.join(".");
}

export function allowAlphabetsWithSpace(value) {
  return value.replace(/[^a-zA-Z\s]/g, "");
}

export function allowAlphaNumericWithLeadingAlpha(value) {
  // Replace characters that are not alphanumeric or spaces
  const sanitized = value.replace(/[^a-zA-Z0-9 ]/g, "");

  // Ensure the first character is a letter
  return /^[a-zA-Z]/.test(sanitized) ? sanitized : "";
}
export function isValidEmail(value) {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(value);
}


export function areMandatoryFieldsFilled(formFields, requiredFields) {
  return requiredFields.every((field) => {
    const value = formFields[field];
    return (
      value !== undefined &&
      value !== null &&
      value !== "" &&
      !(Array.isArray(value) && value.length === 0)
    );
  });
}
